import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { TinyDownArrow } from "./icon/tiny-down-arrow";

export const Expandable = ({ header, answer, children }) => {
  const [toggled, setToggle] = useState();

  const faqSchema = header && answer ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": header,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": answer,
      },
    }],
  } : null;

  return (
    <>
      {faqSchema && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
      )}
      <div
        className="block mb-6 border border-transparent rounded-xl p-4 hover:border-green-emerald text-left bg-white hover:bg-light-80 transition-colors cursor-pointer"
        onClick={() => setToggle(!toggled)}
        role="button"
      >
        <div
          className="font-medium cursor-pointer text-lg transition-colors duration-200"

        >
          <TinyDownArrow
            rotate={toggled ? null : -90}
            className="mr-2 mt-2 float-left transition-transform duration-300"
          />
          {header}
        </div>
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${toggled ? "max-h-screen opacity-100 mt-2" : "max-h-0 opacity-0"}`}
        >
          <div className="text-base leading-relaxed">{children}</div>
        </div>
      </div>
    </>
  );
};
